export default "__VITE_ASSET__C$gb$8bs__"